function generateRandomId() {
  return Math.random().toString(36).substring(2, 9);
}

export default function (totalCharge, quantity, transactionId) {
  gtag("event", "conversion", {
    send_to: "AW-16733286784/wSUECIuv9OIZEIDjhqs-",
    value: totalCharge,
  });

  gtag("event", "purchase", {
    allow_custom_scripts: true,
    value: totalCharge,
    send_to: "DC-17169978/purchase/lakfa00+transactions",
  });

  ttq.track("CompletePayment", {
    value: totalCharge,
    currency: "USD",
  });

  fbq(
    "track",
    "Purchase",
    {
      value: totalCharge,
      currency: "USD",
      quantity: quantity,
    },
    {
      // generate random eventID
      eventID: generateRandomId(),
    },
  );

  // Trade Desk Ticket Purchase pixel (1x1 image)
  try {
    const img = new Image(1, 1);
    img.src = `https://insight.adsrvr.org/track/pxl/?adv=q5084g4&ct=0:vwsqf3y&fmt=3&orderid=${encodeURIComponent(
      "la-kings-" + quantity + "-" + totalCharge,
    )}&v=${encodeURIComponent(totalCharge)}`;
  } catch (e) {
    // no-op: pixel is best-effort only
  }

  // Tradable Bits purchase pixel (1x1 image)
  try {
    const params = new URLSearchParams({
      event_name: "purchase",
      event_amount: String(totalCharge),
      order_key: transactionId,
      purchase_event_name: "FanRally",
      quantity: String(quantity),
      purchase_event_details: "la-kings-membership",
      currency: "USD",
    });
    const tbImg = new Image(1, 1);
    tbImg.src = `https://tradablebits.com/pixels/7177661/event?${params.toString()}`;
  } catch (e) {
    // no-op: pixel is best-effort only
  }
}
